module.exports = __webpack_public_path__ + "img/qr-code-apple.814c954b.png";